import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import axios from 'axios'
import { userKey, urlApi } from '@/config/global'

import Home from '../views/Home'
import Noticia from '../views/Noticia'
//import Artigo from '../views/Artigo'
import Video from '../views/Video'
import Audio from '../views/Audio'
import PesquisaNoticia from '../views/PesquisaNoticia'
import PesquisaVideo from '../views/PesquisaVideo'
//import PesquisaArtigo from '../views/PesquisaArtigo'
//import PesquisaTag from '../views/PesquisaTag'
import AoVivo from '../views/AoVivo'
import AutenticacaoAutomatica from '../views/AutenticacaoAutomatica'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Home,
            name: 'Home',
            meta: { authenticated: false },
        },
        {
            path: '/Noticia/:id/:n?',
            component: Noticia,
            name: 'Noticia',
            nickName: 'Noticia',
            props: true,
            meta: { authenticated: false },
        },
        //{
        //    path: '/Artigo/:id',
        //    component: Artigo,
        //    name: 'Artigo',
        //    nickName: 'Artigo',
        //    props: true,
        //    meta: { authenticated: false },
        //},
        {
            path: '/Video/:id/:n',
            component: Video,
            name: 'Video',
            nickName: 'Video',
            props: true,
            meta: { authenticated: false },
        },
        {
            path: '/Audio/:id/:n',
            component: Audio,
            name: 'Audio',
            nickName: 'Audio',
            props: true,
            meta: { authenticated: false },
        },
        {
            path: '/PesquisaNoticia/',
            component: PesquisaNoticia,
            name: 'PesquisaNoticia',
            nickName: 'PesquisaNoticia',
            props: true,
            meta: { authenticated: false },
        },
        {
            path: '/PesquisaVideo/',
            component: PesquisaVideo,
            name: 'PesquisaVideo',
            nickName: 'PesquisaVideo',
            props: true,
            meta: { authenticated: false },
        },
        //{
        //    path: '/PesquisaArtigo/',
        //    component: PesquisaArtigo,
        //    name: 'PesquisaArtigo',
        //    nickName: 'PesquisaArtigo',
        //    props: true,
        //    meta: { authenticated: false },
        //},
        //{
        //    path: '/PesquisaTag/:id',
        //    component: PesquisaTag,
        //    name: 'PesquisaTag',
        //    nickName: 'PesquisaTag',
        //    props: true,
        //    meta: { authenticated: false },
        //},
        {
            path: '/AoVivo/',
            component: AoVivo,
            name: 'AoVivo',
            nickName: 'AoVivo',
            props: true,
            meta: { authenticated: true },
        },

        {
            path: '/AutenticacaoAutomatica',
            component: AutenticacaoAutomatica,
            name: 'AutenticacaoAutomatica',
        },

        // redirect
        {
            path: '/redirect',
            redirect: '/'
        },
        // 404
        {
            path: '*',
            redirect: '/'
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.authenticated)) {
        // rota logado
        let user = store.getters.getUser

        if (!user) {
            // deslogado
            const json = localStorage.getItem(userKey)
            const userData = JSON.parse(json)

            const req = async () => {
                try {
                    const res = await axios.post(`${urlApi}/Auth/refresh`, userData)
                    if (res.data) {
                        if (res.data.token.authenticated) {
                            res.data.token.usuario = res.data.usuario;
                            res.data.token.usuario.idContrato = res.data.idContrato;
                            res.data.token.usuario.tpPessoa = res.data.tpPessoa;
                            res.data.token.usuario.flCortesia = res.data.flCortesia;
                            store.commit('setUser', res.data.token)
                            next()
                        } else {
                            store.commit('setUser', null);
                            next({ name: 'Home' });
                        }
                    } else {
                        store.commit('setUser', null);
                        next({ name: 'Home' });
                    }
                } catch (err) {
                    store.commit('setUser', null);
                    next({ name: 'Home' });
                }
            };

            req();

        } else {
            // logado
            user.authenticated ? next() : next(false)
        }

    } else {
        // rota deslogado
        
        let user = store.getters.getUser

        if (!user) {
            // deslogado
            const json = localStorage.getItem(userKey)
            const userData = JSON.parse(json)

            if (userData) {
                const req = async () => {
                    try {
                        const res = await axios.post(`${urlApi}/Auth/refresh`, userData)
                        if (res.data) {
                            if (res.data.token.authenticated) {
                                res.data.token.usuario = res.data.usuario;
                                res.data.token.usuario.idContrato = res.data.idContrato;
                                res.data.token.usuario.tpPessoa = res.data.tpPessoa;
                                res.data.token.usuario.flCortesia = res.data.flCortesia;
                                store.commit('setUser', res.data.token)
                                next();
                            } else {
                                store.commit('setUser', null);
                                next();
                            }
                        } else {
                            store.commit('setUser', null);
                            next();
                        }
                    } catch (err) {
                        store.commit('setUser', null);
                        next();
                    }
                };

                req();
            } else {
                next();
            }
            
        } else {
            // logado
            next();
        }
    }
})

export default router